import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";

export default function Sparkline({ data = [], color = "#FFB81C", height = 36 }) {
  const points = data.map((v, i) => ({ i, v: v ?? null }));
  const hasData = points.some((p) => p.v != null);
  if (!hasData) {
    return (
      <div
        className="w-full text-[10px] uppercase tracking-widest text-center pt-2"
        style={{ height, color: "var(--text-muted)" }}
      >
        No SAA history
      </div>
    );
  }
  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <LineChart data={points} margin={{ top: 4, right: 2, bottom: 2, left: 2 }}>
          <YAxis hide domain={["auto", "auto"]} />
          <Line
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={2}
            dot={false}
            isAnimationActive={false}
            connectNulls
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
